// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { upsellsModalStyles } from "@guestsupply/App/Components/Cart/UpsellsModal";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

upsellsModalStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            ${xScreen("lte", "md")} {
                padding: 16px 0;
            }
            ${xScreen("lte", "sm")} {
                && {
                    .middle-section {
                        border-right: none;
                    }
                }
            }
        `,
    },
};
